export { default as titles } from './titles.js';
export { default as paragraphsLists } from './paragraphsLists.js';
export { default as others } from './others.js';

export const FILTERS = [
  {
    key: 'all',
    value: 'all'
  },
  {
    key: 'titles',
    value: 'Titles',
  },
  {
    key: 'paragraphsLists',
    value: 'Paragraphs & Lists',
  },
  {
    key: 'others',
    value: 'Other Copy',
  },
];

export const FILTERKEYS = {
  'titles'         : 'Titles',
  'paragraphsLists': 'Paragraphs & Lists',
  'others'         : 'Other Copy',
};



// WEBPACK FOOTER //
// ./src/containers/foundations/TextStyles/constants/index.js